import { gql } from "urql";

export const ACCEPT_INVITATION_MUTATION = gql`
  mutation AcceptInvitation {
    membershipAcceptInvitation {
      id
    }
  }
`;
